<div *ngIf="errors">
  <div *ngFor="let e of errors | keyvalue">
    <div [ngSwitch]="e.key">
      <small *ngSwitchCase="'required'">Campo obbligatorio</small>
      <small *ngSwitchCase="'email'">Inserire un indirizzo email</small>
      <small *ngSwitchCase="'passwordsMatch'">Le password non coincidono</small>
      <small *ngSwitchCase="'min'">Il valore minimo consentito è {{ e.value?.min }}</small>
      <small *ngSwitchCase="'max'">Il valore massimo consentito è {{ e.value?.max }}</small>
      <!-- <small *ngSwitchCase="'maxlength'">Lunghezza massima di 6 caratteri</small> -->
      <small *ngSwitchDefault>{{ e.value }}</small>
    </div>
  </div>
</div>
